import { Controller } from "@hotwired/stimulus"

// Handles dynamic meeting row addition in onboarding step 4.
// Replaces the inline addMeeting() script.
export default class extends Controller {
  static targets = ["list"]

  add() {
    const list = this.listTarget
    const idx = list.querySelectorAll(".bg-white").length
    const d = list.dataset
    const teamId = d.firstTeamId
    const inp = "w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-[var(--pu-teal)] focus:border-[var(--pu-teal)]"
    const lbl = "block text-xs font-semibold text-gray-600 mb-1"

    const html = `
      <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <div class="flex items-start gap-4">
          <div class="pt-1">
            <input type="hidden" name="meetings[${idx}][enabled]" value="0">
            <input type="checkbox" name="meetings[${idx}][enabled]" value="1" checked
                   class="w-5 h-5 rounded text-[var(--pu-teal)] focus:ring-[var(--pu-teal)]">
          </div>
          <div class="flex-1 space-y-3">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label class="${lbl}">${d.labelName}</label>
                <input type="text" name="meetings[${idx}][name]" placeholder="${d.placeholderName}" class="${inp}">
              </div>
              <div>
                <label class="${lbl}">${d.labelCode}</label>
                <input type="text" name="meetings[${idx}][code]" placeholder="${d.placeholderCode}" class="${inp}">
              </div>
            </div>
            <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
              <div>
                <label class="${lbl}">${d.labelDay}</label>
                <select name="meetings[${idx}][day]" class="${inp}">
                  <option value="monday">${d.optionMonday}</option><option value="tuesday">${d.optionTuesday}</option>
                  <option value="wednesday">${d.optionWednesday}</option><option value="thursday">${d.optionThursday}</option>
                  <option value="friday">${d.optionFriday}</option>
                </select>
              </div>
              <div>
                <label class="${lbl}">${d.labelStart}</label>
                <input type="time" name="meetings[${idx}][start_time]" value="08:00" class="${inp}">
              </div>
              <div>
                <label class="${lbl}">${d.labelEnd}</label>
                <input type="time" name="meetings[${idx}][end_time]" value="09:00" class="${inp}">
              </div>
              <div>
                <label class="${lbl}">${d.labelRecurrence}</label>
                <select name="meetings[${idx}][recurrence]" class="${inp}">
                  <option value="weekly">${d.optionWeekly}</option><option value="biweekly">${d.optionBiweekly}</option>
                  ${[1, 2, 3, 4].map((nth) => `<option value="monthly_${nth}">${d.optionMonthly.replace("%{nth}", nth)}</option>`).join("")}
                </select>
              </div>
            </div>
            <div>
              <label class="${lbl}">${d.labelAttendees}</label>
              <select name="meetings[${idx}][attendees]" class="${inp}">
                <option value="all">${d.optionAttendeesAll}</option><option value="subspecialty">${d.optionAttendeesSub}</option>
              </select>
            </div>
            <input type="hidden" name="meetings[${idx}][team_id]" value="${teamId}">
          </div>
        </div>
      </div>`
    list.insertAdjacentHTML("beforeend", html)
  }
}
